export const schema = {
  accounts: {
    alert: {
      error: {
        container: '',
        later: '',
        message: '',
        title: '',
        try_again: '',
      },
      primary_account: {
        container: '',
        ok: '',
        title: '',
      },
      secondary_account: {
        container: '',
        no: '',
        title: '',
        yes: '',
      },
    },
    button: {
      add_account: '',
      confirm_code: '',
      delete: '',
      send_code: '',
    },
    input: {
      account: '',
      code: '',
    },
    link: {
      tab_email: '',
      tab_phone: '',
    },
    list_item: {
      container: '',
      value: '',
    },
    text: {
      sent_to_value: '',
    },
  },
  addFile: {
    block: {
      loading: '',
    },
    button: {
      confirm: '',
    },
    input: {
      file: '',
    },
  },
  auth: {
    alert: {
      button: {ok: ''},
      error: {
        container: '',
        message: '',
        title: '',
      },
    },
    block: {
      client: '',
      coach: '',
      explain_invite_code: {
        container: {client: '', coach: ''},
        details: '',
        title: '',
      },
      invited_client: '',
    },
    button: {
      account_type: '',
      back: '',
      continue_with_invite: '',
      continue_without_invite: '',
      save_profile: '',
      send_code: '',
      sign_in: '',
      sign_up: '',
      skip_invite: '',
      submit_code: '',
      submit_invite: '',
    },
    checkbox: {
      agree: '',
    },
    input: {
      code: '',
      code_error: '',
      email: '',
      email_error: '',
      invite_code: '',
      invite_code_error: '',
      phone: '',
      phone_error: '',
    },
    link: {
      explain_invite_code: '',
      sign_up: '',
      verification_resend: '',
    },
    text: {
      description: '',
      explain_invite_code: {
        details: '',
        title: '',
      },
      sign_up_error: '',
      title: '',
      verification_email: '',
      verification_phone: '',
      welcome: '',
    },
  },
  bookConference: {
    block: {
      animation: '',
      calendar: '',
      modal: '',
    },
    button: {
      buyMore: '',
      confirm: '',
      timeslot: '',
    },
    input: {
      coachSelect: '',
    },
  },
  calendar_day_picker: {
    button: {
      nav: {
        next: '',
        prev: '',
      },
      pick_day: {
        active: '',
        common: '',
      },
    },
    text: {
      date: '',
      weekday: '',
    },
  },
  certificate: {
    button: {
      add_cover: '',
      delete: '',
      delete_cancel: '',
      delete_confirm: '',
      edit: '',
      save: '',
      show_add_modal: '',
    },
    checkbox: {make_public: ''},
    input: {school: '', title: ''},
    text: {certificate_title: '', school_title: ''},
  },
  change_time_zone: {
    block: {
      alert: '',
      icon: '',
    },
    button: {
      edit_schedule: '',
      ok: '',
    },
  },
  course: {
    block: {
      banner: {
        button: {
          action: '',
        },
        container: '',
        title: '',
      },
      extend_modal: {
        button: {save: ''},
        calendar: '',
      },
      header: {
        avatar: '',
        label: '',
        programTitle: '',
        statusTag: '',
        tag: {
          coach_coverage: '',
          evergreen: '',
          group: '',
          price: '',
        },
      },
      list_item: {
        invites: {
          avatar: '',
          button: {
            action: '',
            more: '',
          },
          container: '',
        },
        members: {
          avatar: '',
          container: '',
        },
        payments: {
          amount: '',
          avatar: '',
          button: {
            action: '',
          },
          container: '',
          description: '',
          status: '',
        },
      },
      no_result: '',
      resources: {
        container: '',
        item: '',
      },
    },
    button: {
      action: {
        book: '',
        delete: '',
        end: '',
        extend: '',
        force_stop: '',
        invite: '',
        more: '',
        pause: '',
        resume: '',
        settings: '',
        start: '',
        stop_evergreen: '',
      },
      tab: {
        clients: '',
        coaches: '',
        invites: '',
        members: '',
        payments: '',
      },
      tools: {
        chat: '',
        goals: '',
        library: '',
        todos: '',
      },
    },
  },
  create_program: {
    button: {
      back: '',
      continue: '',
    },
  },
  create_program_description: {
    button: {
      cover: '',
    },
    input: {
      description: '',
      title: '',
    },
  },
  create_program_details: {
    block: {
      payment_option: {
        custom: '',
        free: '',
      },
      program_type: {
        group: '',
        individual: '',
      },
    },
    button: {
      duration: {
        confirm: '',
        day: '',
        month: '',
        open: '',
        week: '',
      },
      individual_conference_duration: '',
      monthly_payment_plan: '',
    },
    input: {
      duration: '',
      max_size: '',
      number_of_sessions: '',
    },
  },
  create_program_goals: {
    button: {
      add_main_goal: '',
      create: '',
    },
    input: {
      description: '',
      title: '',
    },
  },

  create_program_schedule: {
    button: {
      add_conference: '',
      add_task: '',
      clear: '',
    },
  },

  dashboard: {
    block: {
      h1: '',
    },
    button: {
      add_program: '',
      contacts: '',
      edit_profile: '',
      finances: '',
      joined_programs: '',
      library: '',
      practice: '',
      services: '',
      session_notes: '',
      toolbox: '',
    },
    link: {
      to_practice: '',
    },
  },

  edit_coach_profile: {
    button: {
      add_cover: '',
      avatar_change: '',
      avatar_delete: '',
      category: '',
      change_cover: '',
      delete_cover: '',
      edit_cover: '',
      save: '',
    },
    checkbox: {mentorship: ''},
    input: {
      description: '',
      description_error: '',
      name: '',
      name_error: '',
    },
    text: {error: '', title: ''},
  },

  edit_location: {
    block: {location_item: ''},
    input: {location: ''},
    text: {title: ''},
  },

  edit_profile: {
    button: {
      avatar: '',
      avatar_change: '',
      avatar_delete: '',
      avatar_edit: '',
      create_practice: '',
      save: '',
    },
    checkbox: {newsletters: ''},
    input: {
      location: '',
      name: '',
      name_error: '',
    },
    select: {
      age: '',
      gender: '',
    },
    text: {error: '', title: ''},
  },

  edit_week_schedule: {
    button: {from: '', intro_call_duration: '', save: '', to: ''},
    checkbox: {
      day: '',
      intro_call: '',
    },
  },

  fd: {
    crud: {
      add_product: {
        button: {
          save: '',
        },
        container: '',
        select: {
          measure: '',
          quantity: '',
        },
        text: {measure: '', quantity: ''},
      },
      alert: {
        lost_changes_warning: {
          button: {
            cancel: '',
            ok: '',
          },
          container: '',
        },
      },
      block: {
        avatar: '',
        avatar_empty: '',
        product: {
          button: {
            add: '',
            delete: '',
          },
          checkbox: '',
          container: '',
          description: '',
          title: '',
        },
      },
      button: {
        aside_tab: {
          nutrients: '',
          products: '',
        },
        avatar_context_menu: {
          delete: '',
          open: '',
          show: '',
          update: '',
        },
        delete: '',
        save: '',
        search_mode_tab: {
          custom: '',
          provider: '',
        },
        search_pagination: {
          next: '',
          prev: '',
        },
        share: '',
      },
      input: {
        custom_title: '',
        notes: '',
        search: '',
        time: '',
        time_toggle: '',
      },
      nutritional_info: {
        item: '',
        text: {
          item_name: '',
          item_value: '',
        },
      },
      text: {
        aside_title: '',
        description: '',
        empty_search_result: '',
        no_added_products: '',
        notes: '',
        search_pagination: '',
        search_title: '',
        time_input: '',
        title: '',
        title_input: '',
      },
    },

    main: {
      banner: {
        button: {
          settings: '',
          share: '',
        },
        text: {
          description: '',
          title: '',
        },
      },
      button: {
        add_trackers: '',
        edit_trackers: '',
      },
      calendar: {
        button: {
          open_browser_datepicker: '',
          today: '',
        },
        text: {
          month: '',
          year: '',
        },
      },
      main_tracker: {
        text: {
          current_value: '',
          title: '',
          total_value: '',
        },
      },
      meal: {
        container: '',
        text: {
          time: '',
          title: '',
          tracker_name: '',
          tracker_value: '',
        },
      },
      text: {
        empty_trackers: '',
        meals_title: '',
        trackers_title: '',
      },
      tracker: {
        text: {
          title: '',
          value: '',
        },
      },
    },
    onboarding: {
      button: {
        back: '',
        continue: '',
        hide_main_tracker: '',
        select_tracker: '',
        select_tracker_main: '',
        show_main_tracker: '',
        skip: '',
        step_change: '',
      },
      input: {
        goal: '',
      },
      text: {
        description: '',
        intro_description: '',
        title: '',
        tracker_title: '',
      },
    },
    trackers: {
      button: {
        add_tracker: '',
        edit_tracker: '',
        remove_tracker: '',
        set_main_tracker: '',
      },
      text: {
        empty_trackers_list: '',
        title: '',
        tracker_description: '',
        tracker_list_item_title: '',
        tracker_title: '',
      },
    },
  },

  file_list_item: {
    block: {
      container: '',
      icon: '',
    },
    button: {
      delete: '',
      more: '',
    },
    text: {
      size: '',
      title: '',
      url: '',
    },
  },
  generic: {
    button: {
      ok: '',
    },
  },
  main_menu: {
    button: {
      chats: '',
      community: '',
      content: '',
      goals: '',
      my_coaches: '',
      profile: '',
      to_dos: '',
      tutorials: '',
      widget: '',
    },
  },
  menu: {
    button: {
      login_public: '',
      logout: '',
      more: '',
      notifications: '',
      support: '',
      switchEnv: '',
    },
  },

  modal: {
    button: {close: ''},
    text: {title: ''},
  },

  my_profile: {
    block: {
      user_name: '',
    },
    button: {
      edit_profile: '',
    },
  },

  practice: {
    button: {
      add_program: '',
      availability: '',
      certificates: '',
      edit_practice: '',
      send_message: '',
      share_practice: '',
    },
    text: {
      bookIntroCall: '',
      practice_description: '',
      title: '',
    },
  },

  privacy_policy_update: {
    block: {
      alert: '',
      icon: '',
    },
    button: {
      agree: '',
      decline: '',
    },
  },
  private_profile: {
    additional_data: {
      answer: '',
      container: '',
      question: '',
    },
    container: '',
    text: {
      cell_title: '',
      cell_value: '',
      section_title: '',
    },
  },

  program: {
    alert: {
      delete: {
        container: '',
        message: '',
        no: '',
        title: '',
        yes: '',
      },
    },
    block: {context_menu: {item: ''}},
    button: {
      more: '',
    },
  },

  schedule_event: {
    button: {
      bi_weekly: '',
      daily: '',
      monthly: '',
      one_time: '',
      save: '',
      weekly: '',
    },
    input: {
      description: '',
      duration: '',
      start_day: '',
      stop_day: '',
      time: '',
      title: '',
    },
  },

  see_program: {
    button: {
      close_new_requests: '',
      create_course: '',
      delete: '',
      edit: '',
      hide_program: '',
      invite: '',
      more: '',
      publish: '',
      share: '',
      sign_in_program: '',
    },
    course: {
      button: {
        calendar: '',
        channel: '',
        delete: '',
        library: '',
        start: '',
        stop: '',
      },
    },
  },

  squad: {
    button: {
      bookConference: '',
    },
  },

  sync_private_profile: {
    alert: '',
    button: {
      cancel: '',
      sync: '',
    },
  },
  time_select: {
    button: {
      ampm: '',
      confirm: '',
      hour: '',
      minute: '',
    },
  },
  user_sign_up: {
    button: {
      add_avatar: '',
      avatar_step_continue: '',
      back: '',
      category_item: '',
      continue: '',
      goal_track: '',
      skip: '',
      skip_avatar: '',
      skip_tour: '',
      upload_photo: '',
      watch_later: '',
    },
    checkbox: {
      main_category_item: '',
      secondary_category_item: '',
      use_name: '',
    },
    input: {
      birthday: '',
      location: '',
      name: '',
      nick: '',
    },
    text: {add_avatar_hint: ''},
  },
};
